<template>
  <div class="login-container">
    <div class="login-logo">
      <img src="@/assets/images/merida-logo.png" alt="迈睿达Logo" />
    </div>
    <div class="login-box">
      <div class="login-header">
        <h1>迈睿达制造供应链管理平台</h1>
      </div>
      <div class="login-form">
        <a-tabs>
          <a-tab-pane key="account" tab="账号密码">
            <a-form :model="loginForm" @submit.prevent="handleLogin">
              <a-form-item>
                <a-input v-model:value="loginForm.username" placeholder="请输入账号" size="large">
                  <template #prefix>
                    <user-outlined />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input-password v-model:value="loginForm.password" placeholder="请输入密码" size="large">
                  <template #prefix>
                    <lock-outlined />
                  </template>
                </a-input-password>
              </a-form-item>
              <!-- <a-form-item>
                <a-input v-model:value="loginForm.captcha" placeholder="请输入验证码" size="large" style="width: calc(100% - 100px); margin-right: 8px">
                  <template #prefix>
                    <safety-outlined />
                  </template>
                </a-input>
                <img :src="captchaUrl" alt="验证码" style="height: 40px; cursor: pointer" @click="refreshCaptcha" />
              </a-form-item> -->
              <a-form-item>
                <a-checkbox v-model:checked="loginForm.remember">记住密码</a-checkbox>
                <a style="float: right" href="#">忘记密码？</a>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" size="large" block>立即登录</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="login-footer">
        Powered by 迈睿达 Copyright © 迈睿达供应链股份有限公司
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons-vue'

const router = useRouter()

const loginForm = reactive({
  username: '',
  password: '',
  captcha: '',
  remember: false
})

const captchaUrl = ref('-3-31280') // 这里应该是后端生成的验证码图片URL

const refreshCaptcha = () => {
  // 刷新验证码的逻辑
}

const handleLogin = async () => {
  // 实现登录逻辑
  if (loginForm.username === 'mrtAdmin' && loginForm.password === '*4b7d7fe') {
    // 保存登录状态
    localStorage.setItem('token', 'admin-token')
    // 登录成功后跳转到首页
    router.push('/')
  } else {
    // 登录失败，提示账号或密码不正确
    alert('账号或密码不正确')
  }
}

</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  background: url('@/assets/images/login-bg.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-logo {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 120px;
    height: auto;

    img {
      width: 100%;
      height: auto;
    }
  }

  .login-box {
    width: 400px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    padding: 32px;
    backdrop-filter: blur(10px);
    margin-left: 500px; // 新增此行，使登录框向右移动500px
    margin-bottom: 150px; // 新增此行，使登录框向右移动500px

    .login-header {
      text-align: center;
      margin-bottom: 32px;

      h1 {
        font-size: 24px;
        color: #1890ff;
        margin: 0;
      }
    }

    .login-form {
      :deep(.ant-tabs-nav) {
        margin-bottom: 24px;
      }

      .ant-form-item:last-child {
        margin-bottom: 0;
      }
    }

    .login-footer {
      text-align: center;
      margin-top: 24px;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>